// extracted by mini-css-extract-plugin
export default {"title":"_7c9f22ac2b","bld":"ae27fcdeae"};